import { Chip, Stack, Typography, useTheme } from "@mui/material";
import { Icon, IconProps } from "@phosphor-icons/react";
import { format } from "date-fns";
import React from "react";

interface SummaryTaskItemProps {
  title: string;
  Icon: Icon;
  IconProps?: IconProps;
  isComplete: boolean;
  completedDate?: string;
}

export default function SummaryTaskItem({
  title,
  Icon,
  IconProps,
  isComplete,
  completedDate,
}: SummaryTaskItemProps) {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      padding={theme.spacing(3, 5)}
    >
      <Stack direction="row" gap={theme.spacing(3)} alignItems="center">
        <Icon
          size={20}
          style={{ flexShrink: 0 }}
          color={isComplete ? theme.palette.success.main : theme.palette.action.active}
          {...IconProps}
        />
        <Stack>
          <Typography variant="body1">{title}</Typography>
          {isComplete && completedDate && (
            <Typography variant="body2" color="text.secondary">
              Completed {format(new Date(completedDate), "MMMM do h:mm a")}
            </Typography>
          )}
        </Stack>
      </Stack>

      <Chip
        label={isComplete ? "Complete" : "Incomplete"}
        color={isComplete ? "success" : "default"}
        size="small"
        variant="outlined"
      />
    </Stack>
  );
}
